import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSeo } from "../components/site/Seo";
import { ProductCard, SectionHeader } from "../components/site/Cards";
import { useSite } from "../context/SiteContext";

export default function Pricing() {
  const { exams } = useSite();
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("all");
  useSeo({ title: "Test Series & Pricing | Agni Shiksha", description: "All Agni Shiksha test series and pricing for SSC, UPSC, Banking, Railway and more." });
  useEffect(() => { api.get("/products?limit=100").then((r) => setProducts(r.data)).catch(() => {}); }, []);
  const shown = products.filter((p) => filter === "all" || p.exam_slug === filter);
  return (
    <div className="container-px section-y">
      <SectionHeader eyebrow="Test Series" title="Every exam. One platform." subtitle="Transparent pricing. Free demo on every series." />
      <div className="flex flex-wrap gap-2 mb-8">
        <button onClick={() => setFilter("all")} className={`px-4 py-1.5 rounded-full text-sm border ${filter === "all" ? "btn-ember border-transparent" : "border-line bg-card"}`} data-testid="pricing-filter-all">All</button>
        {exams.map((e) => (
          <button key={e.slug} onClick={() => setFilter(e.slug)} className={`px-4 py-1.5 rounded-full text-sm border ${filter === e.slug ? "btn-ember border-transparent" : "border-line bg-card"}`} data-testid={`pricing-filter-${e.slug}`}>{e.name}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {shown.map((p) => <ProductCard key={p.id} p={p} />)}
      </div>
      {shown.length === 0 && <div className="card-surface p-10 text-center text-content-muted">No products found.</div>}
    </div>
  );
}
